import { render, staticRenderFns } from "./Trainer.vue?vue&type=template&id=3a4fd800"
import script from "./Trainer.vue?vue&type=script&lang=ts"
export * from "./Trainer.vue?vue&type=script&lang=ts"
import style0 from "./Trainer.vue?vue&type=style&index=0&id=3a4fd800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports